import { __extends } from "tslib";
import { BatchExecuteStatementInput, BatchExecuteStatementOutput } from "../models/models_0";
import { deserializeAws_json1_0BatchExecuteStatementCommand, serializeAws_json1_0BatchExecuteStatementCommand, } from "../protocols/Aws_json1_0";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
/**
 * <p>
 * This operation allows you to perform batch reads and writes on data stored in DynamoDB, using PartiQL.
 * </p>
 */
var BatchExecuteStatementCommand = /** @class */ (function (_super) {
    __extends(BatchExecuteStatementCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function BatchExecuteStatementCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    BatchExecuteStatementCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "DynamoDBClient";
        var commandName = "BatchExecuteStatementCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: BatchExecuteStatementInput.filterSensitiveLog,
            outputFilterSensitiveLog: BatchExecuteStatementOutput.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    BatchExecuteStatementCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_0BatchExecuteStatementCommand(input, context);
    };
    BatchExecuteStatementCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_0BatchExecuteStatementCommand(output, context);
    };
    return BatchExecuteStatementCommand;
}($Command));
export { BatchExecuteStatementCommand };
//# sourceMappingURL=BatchExecuteStatementCommand.js.map